/**
 * The Perks component
 */
import React from "react";
import PropTypes from "prop-types";
import { Col, Row } from "reactstrap";
// import logo from '../../assets/images/myfolie-logo.svg';
import icon_assembly from "../../assets/images/icons/perks/tools.svg";
import icon_shipping from "../../assets/images/icons/perks/fast-delivery.svg";
import icon_production from "../../assets/images/icons/perks/factory.svg";
import icon_design from "../../assets/images/icons/perks/paint-palette-and-brush.svg";

/**
 * Stateless react component to render the About page
 * @param {Object} props the props passed to the page.
 */
const PerksSmall = (props, context) => {
  const perkEntrys = [
    {
      image: icon_assembly,
      title: context.t("Delivered ready for assembly"),
    },
    {
      image: icon_shipping,
      title: context.t("Express & EU-wide shipping"),
    },
    {
      image: icon_production,
      title: context.t("In-House production"),
    },
    {
      image: icon_design,
      title: context.t("Your individual Design"),
    },
  ];
  return (
    <div className="my-2 py-3">
      <p className="h6 mb-4">{context.t("Your Benefits with myfolie")}</p>
      <Row>
        {perkEntrys.map((perk) => (
          <Col xl={3} xs={6} key={perk.title}>
            <div className="text-center small mb-3">
              {perk.image && (
                <div className="perks_small__imgwrapper mx-auto">
                  <img
                    src={perk.image}
                    className="img-fluid"
                    alt={perk.title}
                    title={perk.title}
                    width="24"
                    height="24"
                    loading="lazy"
                  />
                </div>
              )}
              <p className="py-2">{perk.title}</p>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};
PerksSmall.contextTypes = {
  t: PropTypes.func,
};
export default PerksSmall;
